/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPayReward.vue?vue&type=template&id=c42b08d6&scoped=true"
import script from "./popPayReward.vue?vue&type=script&lang=js"
export * from "./popPayReward.vue?vue&type=script&lang=js"
import style0 from "./popPayReward.vue?vue&type=style&index=0&id=c42b08d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42b08d6",
  null
  
)

export default component.exports